import { AbstractControl } from "@angular/forms";

// tslint:disable-next-line:typedef
export const PasswordMatcher = (control: AbstractControl): { [key: string]: boolean } | null => {
    const password: AbstractControl | null = control.get("password");
    const confirmPassword: AbstractControl | null = control.get("confirmPassword");
    if (!password || !confirmPassword) {
        return null;
    }
    if (password.value === confirmPassword.value) {
        return null;
    } else {
        return { nomatch: true };
    }
};